import { AspectRatio, Box, Flex, Heading } from "@radix-ui/themes";
import React from "react";

import "../styles/partner-card.css";

export function PartnerCard({
  logo,
  heading,
  children,
}: {
  logo: React.ReactNode
  heading: string;
  children: React.ReactNode;
}) {
  return (
    <Flex
      className="partner-card"
      direction="column"
      p={{
        initial: "4",
        md: "6",
      }}
    >
      <Box>
        <Box maxHeight="100px" height="100px" overflow="hidden">
          <AspectRatio
            ratio={6 / 1}
          >
             {logo}
          </AspectRatio>
        </Box>
        <Heading className="partner-heading" as="h3" size="6">
          {heading}
        </Heading>
      </Box>
      {children}
    </Flex>
  );
}
